import { render, staticRenderFns } from "./AddNote.vue?vue&type=template&id=36cb10b0&"
import script from "./AddNote.vue?vue&type=script&lang=js&"
export * from "./AddNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36cb10b0')) {
      api.createRecord('36cb10b0', component.options)
    } else {
      api.reload('36cb10b0', component.options)
    }
    module.hot.accept("./AddNote.vue?vue&type=template&id=36cb10b0&", function () {
      api.rerender('36cb10b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/supplierDetailPages/AddNote.vue"
export default component.exports